"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectMarkAsReadOption')(function selectMarkAsReadOption(choice, state) {
    var optionState = state.optionState;
    optionState.behavior = choice === 'Instant' ? 'Delayed' : choice;
    // TODO: VSO:13206 - Implement a customizable delay
    optionState.delay = choice === 'Instant' ? 0 : 5;
}));
//# sourceMappingURL=selectMarkAsReadOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-mark-as-read-option/lib/actions/selectMarkAsReadOption.js
// module id = 5044
// module chunks = 2